import { createNavigation } from 'next-intl/navigation'

import { routing } from './routing'

// ! Always use these variables instead of variables with the same name imported from 'next'.
const { Link, redirect: redirect_, usePathname, useRouter, getPathname } = createNavigation(routing)

const redirect = (href: string) => {
  return redirect_({ href, locale: 'en' })
}

export { Link, usePathname, useRouter, getPathname, redirect }
